/**
 *  API URL Config
 */

// export const IAM_PATH = 'http://10.10.10.101:8080';
// export const IAM_PATH = process.env.REACT_APP_SERVER_PATH;
export const IAM_PATH = 'https://admin.adduce.co.kr:8443';
export const IAM_SERVER_SERVICE_GROUP = "/rest/group";
export const IAM_SERVER_SERVICE_ACOUNT = "/rest/account";
export const IAM_SERVER_SERVICE_PRODUCT = "/rest/product";
export const IAM_SERVER_SERVICE_LICENSE = "/rest/plan";
export const IAM_SERVER_SERVICE_USER = "/rest/admin";

//로그 현황 페이지 controller API 주소
export const IAM_SERVER_AUDIT_ADMIN = '/rest/audits';

//로그 현황 페이지 controller API 주소
export const IAM_SERVER_DASHBOARD = '/rest/dashboard';
